// src/hooks/useSocket.ts
import { useEffect, useState } from "react";
import { getSocket, setSocketAuthToken, trackRoom, untrackRoom } from "@/lib/socket";

import { fetchWithAuth } from '../lib/fetchWithAuth';
type UseSocketOpts = { joinThreadId?: string };

export function useSocket({ joinThreadId }: UseSocketOpts = {}) {
  const [connected, setConnected] = useState(false);
  const s = getSocket();

  useEffect(() => {
    if (!s) return;

    let cancelled = false;

    (async () => {
      const res = await fetchWithAuth("/api/socket-token", { credentials: "include" });
      if (!res.ok) throw new Error("Failed to get socket token");
      const { token } = (await res.json()) as { token: string };

      if (cancelled || !s) return;
      setSocketAuthToken(token);
      if (s.disconnected) s.connect();

      const onConnect = () => !cancelled && setConnected(true);
      const onDisconnect = () => !cancelled && setConnected(false);
      s.on("connect", onConnect);
      s.on("disconnect", onDisconnect);

      if (joinThreadId) {
        trackRoom(joinThreadId); // auto-rejoin handled globally
      }
    })();

    return () => {
      cancelled = true;
      setConnected(false);
      if (s && joinThreadId) untrackRoom(joinThreadId);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [joinThreadId]);

  return { socket: s, connected };
}
